/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import CurrentSupportPlanCard from './index/current-support-plan-card';
import { hasScheduledChanges } from 'state/current-support/selectors';
import ScheduledChangesCard from './index/scheduled-changes';
import SupportDetailsCard from './index/support-details-card';
import BillingDetailsCard from './index/billing-details-card';
import ScheduledChangesNotice from './scheduled-changes-notice';
import { Stack, Box } from '@towersystems/towersystems-design-system';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';

/**
 * Style dependencies
 */
import './styles.scss';

const Support = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Support Plan - Tower Systems' />
            <Topbar title='Support Plan' subTitle='Manage your support plan' selected='support'>
                <ButtonGroup>
                    <Button primary link='/dashboard/support/edit'>
                        Change Support Plan
                    </Button>
                </ButtonGroup>
            </Topbar>
            {props.hasScheduledChanges && <ScheduledChangesNotice />}
            <Main padding='xxlarge'>
                <Stack space='large'>
                    <CurrentSupportPlanCard />
                    {props.hasScheduledChanges && <ScheduledChangesCard />}
                    <SupportDetailsCard />
                    <BillingDetailsCard />
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(Support);
